<template>
  <CContainer class="pt-5" fluid>
    <CRow>
      <CCol class="col-7">
        <h3 class="pl-3 mb-0 pb-0">APHT Payment</h3>
        <b-breadcrumb class="my-0 pt-1" style="border-bottom: 0px">
          <b-breadcrumb-item active>
            <CIcon name="cil-credit-card" />
            Created
          </b-breadcrumb-item>
        </b-breadcrumb>
      </CCol>
    </CRow>
    <CCard class="custom-card">
      <CCardBody class="px-0 pb-0">
        <CRow class="mt-2">
          <CCol class="col-lg-12 col-xl-8 ml-5">
            <CForm>
              <b-input-group class="custom-input-group-white mb-2">
                <b-input-group-prepend>
                  <b-form-select class="period-by-select custom-input-prepend" v-model="filter.periodBy" :options="filter.periodOptions" @change="onChangeFilterDate"></b-form-select>
                </b-input-group-prepend>
                <b-input-group-append>
                  <b-form-datepicker
                    reset-button
                    v-model="filter.periodStart" 
                    :max="filter.maxPeriodStart"
                    id="filter-period-start"
                    placeholder="DD/MM/YYYY"
                    class="custom-label-date"
                    :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                    locale="id"
                    @context="onContextPeriodStart"
                    @input="getTableItems()"
                  ></b-form-datepicker>
                </b-input-group-append>
                <b-input-group-append>
                  <b-input-group-text>
                    ~
                  </b-input-group-text>
                </b-input-group-append>
                <b-input-group-append>
                  <b-form-datepicker
                    reset-button
                    v-model="filter.periodEnd" 
                    :min="filter.minPeriodEnd"
                    placeholder="DD/MM/YYYY"
                    class="custom-label-date"
                    :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                    locale="id"
                    @context="onContextPeriodEnd"
                    @input="getTableItems()"
                  ></b-form-datepicker>
                </b-input-group-append>
              </b-input-group>
            </CForm>
          </CCol>
        </CRow>
        <CRow class="mt-2">
          <CCol class="col-xs-10 col-sm-9 col-md-7 col-lg-7 col-xl-5 ml-5">
            <CForm>
              <b-input-group class="custom-input-group-white">
                <b-input-group-prepend class="custom-prepend-middle">
                  <b-form-select v-model="filter.filterType" :options="filter.options" @change="onChangeFilterType"></b-form-select>
                </b-input-group-prepend>
                <b-form-select v-if="filter.filterType == 'invoiceMemoStatus'" v-model="filter.filterValue" :options="filter.filterValueMemoStatusOptions"></b-form-select>
                <b-form-select v-else-if="filter.filterType == 'paymentStatusNotary'" v-model="filter.filterValue" :options="filter.filterValuePaymentNotaryStatusOptions"></b-form-select>
                <b-form-select v-else-if="filter.filterType == 'paymentStatusPnbp'" v-model="filter.filterValue" :options="filter.filterValuePaymentPnbpStatusOptions"></b-form-select>
                <b-form-input v-else-if="filter.filterType == 'invoiceNoNotary' || filter.filterType == 'invoiceNoPnbp'" v-model="filter.filterValue" maxlength="50" autocomplete="off" placeholder="Search"></b-form-input>
                <b-form-input 
                  maxlength="50" v-else type="text" placeholder="Search" 
                  :value="filter.filterValue" @input="filter.filterValue = $helper.parseNumber($event)"
                  onkeypress="return (event.charCode >= 48 && event.charCode <= 57) || event.charCode == 13"
                ></b-form-input>
                <b-input-group-append>
                  <CButton size="sm" color="primary" type="submit" title="Filter Tabel" :disabled="!table.isLoaded" @click="filterTable">
                    <CIcon name="cil-magnifying-glass" />
                  </CButton>
                </b-input-group-append>
              </b-input-group>
            </CForm>
          </CCol>
        </CRow>
        <CRow class="mt-4">
          <CCol>
            <b-table striped hover show-empty
              responsive="xl"
              :items="table.items"
              :fields="table.fields"
              :busy="!table.isLoaded"
              no-local-sorting no-sort-reset
              @sort-changed="onTableSortChanged"
            >
              <template #cell(aphtMemoDate)="row">
                {{ $helper.showData(row.value, "shortDate") }}
              </template>
              <template #cell(applNo)="row">
                {{ $helper.showData(row.value, "string") }}
              </template>
              <template #cell(applicationDate)="row">
                {{ $helper.showData(row.value, "shortDate") }}
              </template>
              <template #cell(invoiceMemoStatus)="row">
                <CBadge v-if="row.value == 'OA'" color="secondary"> On Approval
                </CBadge>
                <CBadge v-else-if="row.value == 'AP'" color="success"> Approved
                </CBadge>
                <CBadge v-else-if="row.value == 'RJ'" color="danger"> Rejected
                </CBadge>
                <CBadge v-else-if="row.value == 'RV'" color="warning"> Need Revise
                </CBadge>
                <CBadge v-else color="secondary"> -
                </CBadge>
              </template>
              <template #cell(invoiceNoNotary)="row">
                {{ $helper.showData(row.value, "string") }}
              </template>
              <template #cell(invoiceNoPnbp)="row">
                {{ $helper.showData(row.value, "string") }}
              </template>
              <template #cell(paymentStatusNotary)="row">
                <CBadge v-if="row.value == 'U'" color="secondary"> Unpaid
                </CBadge>
                <CBadge v-else-if="row.value == 'P'" color="success"> Paid
                </CBadge>
                <CBadge v-else color="secondary"> -
                </CBadge>
              </template>
              <template #cell(paymentStatusPnbp)="row">
                <CBadge v-if="row.value == 'U'" color="secondary"> Unpaid
                </CBadge>
                <CBadge v-else-if="row.value == 'P'" color="success"> Paid
                </CBadge>
                <CBadge v-else color="secondary"> -
                </CBadge>
              </template>
              <template #cell(action)="row">
                <CButton size="sm" color="primary" title="Daftar Memo Kontrak" class="btn-icon mr-1" @click="$router.push({ name: 'Invoice APHT Memo List', params: { collateralId: row.item.collateralAphtId } })">
                  <b-icon icon="list"></b-icon>
                </CButton>
                <CButton v-if="!$helper.isEmpty(row.item.invoiceNoPnbp)" size="sm" color="primary" title="Detail Invoice" class="btn-icon" @click="$router.push({ name: 'Invoice APHT Approved Detail', params: { invoiceType: 'pnbp', collateralId: row.item.collateralAphtId} })">
                  <b-icon icon="eye"></b-icon>
                </CButton>
                <CButton v-else-if="!$helper.isEmpty(row.item.invoiceNoNotary)" size="sm" color="primary" title="Detail Invoice" class="btn-icon" @click="$router.push({ name: 'Invoice APHT Approved Detail', params: { invoiceType: 'notary', collateralId: row.item.collateralAphtId} })">
                  <b-icon icon="eye"></b-icon>
                </CButton>
              </template>
              <template slot="empty">
                <div v-if="!table.isLoaded" class="text-center">
                  <b-spinner label="Fetching Data..."></b-spinner>
                </div> 
                <div v-else class="text-center">
                  Tidak ada data
                </div> 
              </template>
            </b-table>
            <CCardFooter>
              <PageSizer :totalRows="table.totalRows" :page="table.currentPage" @limit-change="onTableLimitChange" @page-change="onTablePageChange" />
            </CCardFooter>
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>
  </CContainer>
</template>


<script>
export default {
  name: 'InvoiceApprovedList',
  data() {
    const today = this.$moment().format('YYYY-MM-DD')
    return {
      isDownloading: false,
      filter: {
        options: [
          { value:"applNo", text: "No. Appl." },
          { value:"invoiceMemoStatus", text: "Status" },
          { value:"invoiceNoNotary", text: "Invoice Notaris" },
          { value:"invoiceNoPnbp", text: "Invoice PNBP" },
          { value:"paymentStatusNotary", text: "Pembayaran Notaris" },
          { value:"paymentStatusPnbp", text: "Pembayaran PNBP" }
        ],
        filterValueMemoStatusOptions: [
          { value: "OA", text: "On Approval" },
          { value: "AP", text: "Approved" },
          { value: "RJ", text: "Rejected" },
          { value: "RV", text: "Need Revise" }
        ],
        filterValuePaymentNotaryStatusOptions: [
          { value: "U", text: "Unpaid" },
          { value: "P", text: "Paid" },
        ],
        filterValuePaymentPnbpStatusOptions: [
          { value: "U", text: "Unpaid" },
          { value: "P", text: "Paid" }
        ],
        filterType: 'applNo',
        filterValue: '',
        periodOptions: [
          { value:"aphtMemoDate", text: "Tanggal APHT" },
          { value:"applicationDate", text: "Tanggal Appl." }
        ],
        periodBy: "aphtMemoDate",
        periodStart: null,
        maxPeriodStart: today,
        periodEnd: null,
        minPeriodEnd: '',
        maxPeriodEnd: today
      },
      table: {
        isLoaded: false,
        // table fields mirrors returned object from server-side
        fields: [
          {key: "aphtMemoDate", label: "Tanggal APHT", sortable: true},
          {key: "applNo", label: "No. Appl.", sortable: true},
          {key: "applicationDate", label: "Tanggal Appl.", sortable: true},
          {key: "invoiceMemoStatus", label: "Status", sortable: true},
          {key: "invoiceNoNotary", label: "Invoice Notaris", sortable: true},
          {key: "invoiceNoPnbp", label: "Invoice PNBP", sortable: true},
          {key: "paymentStatusNotary", label: "Pembayaran Notaris", sortable: true},
          {key: "paymentStatusPnbp", label: "Pembayaran PNBP", sortable: true},
          {key: "action", label: "Aksi", sortable: false, class: "custom-column-config-doc-group"}
        ],
        items: [],
        sortBy: null,
        sortDesc: true,
        currentPage: 1,
        perPage: 10,
        totalRows: 0,
        totalPages: 0
      }
    }
  },
  methods: {

    onChangeFilterDate() {
      if (!this.$helper.isEmpty(this.filter.periodStart) && !this.$helper.isEmpty(this.filter.periodEnd)) {
        this.getTableItems()
      }
    },
    onChangeFilterType() {
      if (this.filter.filterType == "invoiceMemoStatus") {
        this.filter.filterValue = "OA"
      }
      else if (this.filter.filterType == "paymentStatusNotary") {
        this.filter.filterValue = "U"
      }
      else if (this.filter.filterType == "paymentStatusPnbp") {
        this.filter.filterValue = "U"
      }
      else{
        this.filter.filterValue = null
      }
    },

    // update datepicker valid dates on change
    onContextPeriodStart() {
      this.filter.minPeriodEnd = this.filter.periodStart
    },
    onContextPeriodEnd() {
      this.filter.maxPeriodStart = this.filter.periodEnd
    },
    // update table with server-side processing on change
    onTableLimitChange(newPerPage) {
      this.table.perPage = newPerPage
      // only fetch data when roles apply
      this.getTableItems()
    },
    onTablePageChange(newPage) {
      // only fetch data when roles apply
      this.getTableItems(newPage)
    },
    onTableSortChanged(ctx) {
      this.table.sortBy = ctx.sortBy
      this.table.sortDesc = ctx.sortDesc
      // only fetch data when roles apply
      this.getTableItems(this.table.currentPage)
    },
    filterTable(event){
      event.preventDefault()
      
      this.getTableItems()
    },
    // get paginated table contents from server-side
    getTableItems(page = 1) {
      // URL builder
      let getUrl = "/aphtPayment/getCollateralToCreateMemo"
      let params = {}
      params['page'] = (page - 1)
      params['size'] = this.table.perPage
      if(!this.$helper.isEmpty(this.filter.periodBy) && !this.$helper.isEmpty(this.filter.periodStart) && !this.$helper.isEmpty(this.filter.periodEnd)){
        params['periodBy'] = this.filter.periodBy
        params['periodStart'] = this.filter.periodStart
        params['periodEnd'] = this.filter.periodEnd
      }
      if(!this.$helper.isEmpty(this.filter.filterType) && !this.$helper.isEmpty(this.filter.filterValue)) {
        params['filterType'] = this.filter.filterType
        params['filterValue'] = this.filter.filterValue
      }
      if(this.table.sortBy != null) {
        params['sortBy'] = this.table.sortBy
        params['asc'] = !this.table.sortDesc
      }
      // only send axios request if role is valid
      if(this.$helper.isRole(this.$availRoles['Cabang']) || this.$helper.isRole(this.$availRoles['FIMS']) || this.$helper.isRole(this.$availRoles['HO'])){
        this.table.isLoaded = false
        this.$axios.get(getUrl, {params: params}).then(response => {
          if(response.status == 200){
            sessionStorage.setItem("filterInvoiceApprovedListPeriodBy", this.filter.periodBy)
            sessionStorage.setItem("filterInvoiceApprovedListPeriodStart", this.filter.periodStart)
            sessionStorage.setItem("filterInvoiceApprovedListPeriodEnd", this.filter.periodEnd)
            sessionStorage.setItem("filterInvoiceApprovedListType", this.filter.filterType)
            sessionStorage.setItem("filterInvoiceApprovedListValue", this.filter.filterValue)
            this.table.items = response.data.data.data
            this.table.totalRows = response.data.data.totalElements
            this.table.totalPages = response.data.data.totalPages
          }
          else{
            this.$helper.toastError(this, "Load Daftar Kontrak Gagal! " + (!this.$helper.isEmpty(response.data.reason) ? response.data.reason : ""))
          }
        })
        .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Load Daftar Kontrak Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : "Endpoint Not Found"))
          }
          else{
            this.$helper.toastError(this, "Load Daftar Kontrak Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
        })
        .finally(() => {
          this.table.isLoaded = true
        })
      }
      else{
        this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
      }
    }
  },
  computed: {
  },
  mounted() {
    if(!this.$helper.isEmpty(sessionStorage.getItem("filterInvoiceApprovedListPeriodBy"))){
      this.filter.periodBy = sessionStorage.getItem("filterInvoiceApprovedListPeriodBy")
    }
    if(!this.$helper.isEmpty(sessionStorage.getItem("filterInvoiceApprovedListPeriodStart"))){
      this.filter.periodStart = sessionStorage.getItem("filterInvoiceApprovedListPeriodStart")
    }
    if(!this.$helper.isEmpty(sessionStorage.getItem("filterInvoiceApprovedListPeriodEnd"))){
      this.filter.periodEnd = sessionStorage.getItem("filterInvoiceApprovedListPeriodEnd")
    }
    if(!this.$helper.isEmpty(sessionStorage.getItem("filterInvoiceApprovedListType"))){
      this.filter.filterType = sessionStorage.getItem("filterInvoiceApprovedListType")
    }
    if(!this.$helper.isEmpty(sessionStorage.getItem("filterInvoiceApprovedListValue"))){
      this.filter.filterValue = sessionStorage.getItem("filterInvoiceApprovedListValue")
    }
    // get table contents on page load
    this.getTableItems()
  },
  created() {
  }
}
</script>

<style>

</style>
